import type { CompanyViewModel } from 'ab-viewModels/company.viewModel';

import type { FieldReportSettingsFormToModel, FieldReportSettingsRM } from 'ab-requestModels/company/fieldReportSettings.requestModel';

export const fromVMtoRM = (company: CompanyViewModel): FieldReportSettingsRM => {
	return {
		fieldReportAccessDayDuration: company.fieldReportAccessDayDuration,
		isFRManageAllowedToApproveTimeSheet: company.isFRManageAllowedToApproveTimeSheet,
		isFRManageAllowedToEditTimeSheet: company.isFRManageAllowedToEditTimeSheet,
		isFRManageLevelAllowedInReviewProcess: company.isFRManageLevelAllowedInReviewProcess,
		allowAllNonBillableShortcut: company.allowAllNonBillableShortcut,
	};
};

export const fromFMtoRM = (form: FieldReportSettingsRM): FieldReportSettingsFormToModel => {
	return {
		fieldReportAccessDayDuration: +form.fieldReportAccessDayDuration,
		isFRManageAllowedToApproveTimeSheet: form.isFRManageAllowedToApproveTimeSheet,
		isFRManageAllowedToEditTimeSheet: form.isFRManageAllowedToEditTimeSheet,
		isFRManageLevelAllowedInReviewProcess: form.isFRManageLevelAllowedInReviewProcess,
		allowAllNonBillableShortcut: form.allowAllNonBillableShortcut,
	};
};
